module.exports = __webpack_public_path__ + "img/co2_warning.5c3e580e.svg";